import React, { useState, useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Header.css";
import { validateToken } from "../pages/ValidateToken";
import axios from "axios";
import config from "../config/config.json";
import SearchIcon from "@mui/icons-material/Search";
import { InputBase, Box, List, ListItem, ListItemText } from "@mui/material";
import { urls } from "./URLs";

const navitems = [
  { text: "About UTahData.org", to: "/about-us" },
  { text: "Utah At a Glance", to: "/utah-at-a-glance" },
  { text: "Utah Key Economic Verticals", to: "/verticals" },
  { text: "Utah Gallery", to: "/gallery" },
  { text: "Search", to: "/search" },
  // { text: "Login", to: "/login" },
  { text: "Contact Us", to: "/contact-us" },
];

const Header = ({ scrollContainerRef }) => {
  const searchRef = useRef(null);
  const navigate = useNavigate();
  const [username, setUsername] = useState(localStorage.getItem("username"));
  const [user, setUser] = useState(null);
  // const username = localStorage.getItem("user");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [validToken, setValidToken] = useState(null);
  const handleNavigate = () => {
    navigate("/profile");
  };

  const handleClick = () => navigate("/");
  const goto = useCallback(
    (to) => {
      navigate(to);
      setIsMenuOpen(false);
    },
    [navigate],
  );

  const [scrolled, setScrolled] = useState(false);
  // useEffect(() => {
  //   axios
  //     .get("https://utsb.utahdata.org/bdxbackend/auth/me", {
  //       withCredentials: true,
  //     })
  //     .then(({ data }) => {
  //       if (data.authenticated) {
  //         setValidToken(true);
  //         setUser(data.user);
  //       } else {
  //         setUser(null);
  //       }
  //     })
  //     .catch(() => setUser(null));
  // }, []);
  useEffect(() => {
    const checkToken = async () => {
      const token = localStorage.getItem("token");
      console.log("Token from localStorage:", token);

      if (!token) {
        setValidToken(false);
        setUsername(null);
        localStorage.removeItem("username");
        return;
      }

      const { valid, user } = await validateToken(token);
      console.log("Validation Response:", { valid, user });

      if (!valid) {
        setValidToken(false);
        setUsername(null);
        localStorage.removeItem("username");
        return;
      }

      setValidToken(true);
    };

    checkToken();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setSearchTerm(""); // Clear search
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Listen for storage changes (e.g., when token is removed from another tab/context)
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "token" && !e.newValue) {
        // Token was removed
        setValidToken(false);
        setUsername(null);
        localStorage.removeItem("username");
      } else if (e.key === "username" && !e.newValue) {
        // Username was removed
        setUsername(null);
      } else if (e.key === "username" && e.newValue) {
        // Username was added
        setUsername(e.newValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 10); // Adjust the scroll threshold if needed
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const scrollElement = scrollContainerRef?.current;
    if (!scrollElement) return;

    const onScroll = () => {
      setScrolled(scrollElement.scrollTop > 10); // Use scrollTop, not scrollY
    };

    scrollElement.addEventListener("scroll", onScroll);
    return () => scrollElement.removeEventListener("scroll", onScroll);
  }, [scrollContainerRef]);

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setDropdownOpen(!isDropdownOpen);
  };

  // useEffect(() => {
  //   const checkToken = async () => {
  //     const token = localStorage.getItem("token");
  //     console.log("Token from localStorage:", token);

  //     if (!token) {
  //       setValidToken(false);
  //       return;
  //     }

  //     const { valid, user } = await validateToken(token);
  //     console.log("Validation Response:", { valid, user });

  //     if (!valid) {
  //       setValidToken(false);
  //       return;
  //     }

  //     setValidToken(true);
  //   };

  //   checkToken();
  // }, []);

  // useEffect(() => {
  //   if (validToken !== null) {
  //     console.log("✅ Is token valid?", validToken);
  //   }
  // }, [validToken]);

  const handleLogout = (e) => {
    // Add your logout logic here (e.g., clearing the session, redirecting, etc.)
    //console.log('Logged out');
    e.preventDefault();
    // call logout API which clears the cookie
    axios
      .post(config.APP_URL + "/utahdata/logout", {}, { withCredentials: true })
      .then(() => {
        setUser(null);
        setValidToken(false);
        setUsername(null);
        localStorage.removeItem("username");
        window.location.href = "https://utahdata.org/login"; // redirect to main login
      })
      .catch((err) => console.error("Logout error:", err));
    localStorage.removeItem("token");
    setUsername(null);
    navigate("/login");
    console.log("Logged out");
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const [searchTerm, setSearchTerm] = useState("");

  const filteredUrls = urls.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div>
      <header className={`header ${scrolled ? "scrolled" : ""} z-[1400]`}>
        <img
          src="/img/UTDT_Logo.png"
          alt="Utah Data Logo"
          className="logo"
          onClick={handleClick}
        />
        <div className="flex flex-row gap-3 items-center">
          <Box ref={searchRef} className="search_box">
            {/* Search Input */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                background: "#00000050",                
                padding: "5px 10px",
                borderRadius: 2,
              }}
            >
              <SearchIcon sx={{ color: "#fff", marginRight: 1 }} />
              <InputBase
                placeholder="Search…"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{ color: "#fff", width: "100%" }}
              />
            </Box>

            {/* Search Results */}
            {searchTerm && (
              <List
                sx={{
                  position: "absolute",
                  top: 45,
                  width: "100%",
                  background: "#ffffff",
                  boxShadow: 3,
                  borderRadius: 1,
                  maxHeight: 600,
                  overflowY: "auto",
                  padding: 0,
                }}
              >
                {filteredUrls.length > 0 ? (
                  filteredUrls.map((item, index) => (
                    <ListItem button key={index} component="a" href={item.path}>
                      <ListItemText primary={item.name} />
                    </ListItem>
                  ))
                ) : (
                  <ListItem>
                    <ListItemText primary="No results found" />
                  </ListItem>
                )}
              </List>
            )}
          </Box>
          {validToken ? (
            <div className="flex gap-2 shadow-2xl text-base no-underline  px-2 py-2 bg-white opacity-80 rounded-lg items-center">
              <div className="relative" ref={dropdownRef}>
                <a className="no-underline" onClick={toggleDropdown}>
                  <span className="text-green-900 shadow-2xl text-base no-underline">
                    {/* <span className="text-green-900 shadow-2xl text-base no-underline inline-block px-2 py-1 bg-white"> */}
                    Hi {(user && user.name) || username || "Guest"}
                  </span>

                  <img
                    src="/img/login1.png"
                    className="h-6 w-auto"
                    alt="Login"
                  />
                </a>

                {isDropdownOpen && (
                  <div className="absolute right-[-10px] mt-2 w-[11rem]  shadow-lg rounded-lg">
                    <button
                      onClick={handleLogout}
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-200 rounded-lg"
                    >
                      Logout
                    </button>
                    <button
                      onClick={handleNavigate}
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-200 rounded-lg"
                    >
                      User Profile
                    </button>
                  </div>
                )}
              </div>
            </div>
          ) : null}

          <div
            className="menu "
            onClick={() => setIsMenuOpen(true)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && setIsMenuOpen(true)}
          >
            <div>☰ MENU</div>
          </div>
        </div>
      </header>

      <div className={`menu-overlay ${isMenuOpen ? "open" : ""}`}>
        <div className="menu-header">
          <div className="menu">☰ MENU</div>
          <span
            className="close-button"
            onClick={() => setIsMenuOpen(false)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && setIsMenuOpen(false)}
          >
            X CLOSE
          </span>
        </div>

        <div className="menu-header-underline"></div>

        <div className="menu-overlay-inner">
          <div className="menu-content">
            <ul>
              {navitems.map((item, index) => (
                <li onClick={() => goto(item.to)} key={index}>
                  <span className="hover-bracket-wrapper">
                    <span className="text">{item.text}</span>
                    <span className="underline"></span>
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <div className="header-background-image" />
        </div>

        <div className="menu-footer">
          <div className="menu-footer-left">©2026 UTahData.org</div>
          <div className="menu-footer-right">
            <div>
              <h4>MAIL</h4>
              <a
                href={`mailto:bodex@bodex.io?subject=${encodeURIComponent(
                  "Interested in UtahData.org",
                )}&body=${encodeURIComponent(
                  "I am interested to learn more about UtahData.org. Please share more details.",
                )}`}
                // className="text-blue-600 underline"
              >
                bodex@bodex.io
              </a>
            </div>
            <div>
              <h4>SOCIAL</h4>
              <div className="menu-footer-social">
                <a
                  href="https://www.facebook.com/profile.php?id=61571797313046"
                  target="_blank"
                >
                  Facebook
                </a>
                <span>|</span>
                <a
                  href="https://www.linkedin.com/company/utahdata/"
                  target="_blank"
                >
                  LinkedIn
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
